export default function (element, data) {
  const content = element.querySelector('.scroller-content');
  if (!content) return;

  let isDragging = false;
  let isTouch = false;
  let hasMoved = false;
  let directionLocked = false;
  let startX = 0;
  let startY = 0;
  let touchStartX = 0;
  let touchStartY = 0;
  let currentX = 0;
  let velX = 0;
  let lastX = 0;
  let lastTime = 0;
  let rafId = null;

  element.style.touchAction = 'pan-y';

  function getMaxScroll() {
    return Math.max(0, content.scrollWidth - element.clientWidth);
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function applyTransform(x) {
    content.style.transform = `translateX(${x}px)`;
  }

  function stopInertia() {
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  }

  function startInertia() {
    stopInertia();
    const friction = isTouch ? 0.98 : 0.95;

    function step() {
      velX *= friction;
      if (Math.abs(velX) < 0.3) {
        velX = 0;
        return;
      }
      currentX = clamp(currentX + velX, -getMaxScroll(), 0);
      applyTransform(currentX);
      rafId = requestAnimationFrame(step);
    }

    rafId = requestAnimationFrame(step);
  }

  function blockNextClick(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  // Mouse events
  element.addEventListener('mousedown', (e) => {
    if (getMaxScroll() === 0) return;
    isDragging = true;
    isTouch = false;
    hasMoved = false;
    startX = e.clientX - currentX;
    lastX = e.clientX;
    lastTime = Date.now();
    velX = 0;
    stopInertia();
    element.style.cursor = 'grabbing';
    e.preventDefault();
  });

  window.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    const now = Date.now();
    const dt = now - lastTime || 1;
    velX = (e.clientX - lastX) / dt * 16;
    lastX = e.clientX;
    lastTime = now;
    currentX = clamp(e.clientX - startX, -getMaxScroll(), 0);
    applyTransform(currentX);
    hasMoved = true;
  });

  window.addEventListener('mouseup', () => {
    if (!isDragging) return;
    isDragging = false;
    element.style.cursor = '';
    if (hasMoved) {
      element.addEventListener('click', blockNextClick, { capture: true, once: true });
    }
    startInertia();
  });

  // Touch events
  element.addEventListener('touchstart', (e) => {
    if (getMaxScroll() === 0) return;
    const touch = e.touches[0];
    isDragging = true;
    isTouch = true;
    hasMoved = false;
    directionLocked = false;
    element.style.touchAction = 'pan-y';
    startX = touch.clientX - currentX;
    touchStartX = touch.clientX;
    touchStartY = touch.clientY;
    lastX = touch.clientX;
    lastTime = performance.now();
    velX = 0;
    stopInertia();
  }, { passive: true });

  element.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    const touch = e.touches[0];

    if (!directionLocked) {
      const dx = Math.abs(touch.clientX - touchStartX);
      const dy = Math.abs(touch.clientY - touchStartY);
      if (dx + dy < 10) return;
      if (dy > dx) {
        isDragging = false;
        return;
      }
      directionLocked = true;
      element.style.touchAction = 'none';
    }

    e.preventDefault();
    const now = performance.now();
    const dt = now - lastTime || 1;
    velX = (touch.clientX - lastX) / dt * 16;
    lastX = touch.clientX;
    lastTime = now;
    currentX = clamp(touch.clientX - startX, -getMaxScroll(), 0);
    applyTransform(currentX);
    hasMoved = true;
  }, { passive: false });

  element.addEventListener('touchend', () => {
    if (!isDragging) {
      return;
    }
    isDragging = false;
    if (hasMoved) {
      element.addEventListener('click', blockNextClick, { capture: true, once: true });
      startInertia();
    }
  });
}
